<template>
    <div
        class="WInput"
        :class="{ error }"
    >
        <WIcon
            v-if="iconLeft && !error"
            class="iconLeft"
            :icon="iconLeft"
            :color="iconColor"
            :size="18"
        />
        <WIcon
            v-if="iconRight && !error"
            class="iconRight"
            :icon="iconRight"
            :color="iconColor"
            :size="18"
        />
        <input
            :id="id"
            :value="value"
            :name="name"
            :type="type"
            :placeholder="placeholder"
            :readonly="readonly"
            :disabled="disabled"
            :class="inputClass"
            v-on="inputListeners"
        >

        <Transition
            name="fade"
            :duration="500"
        >
            <WText
                v-if="error"
                class="Error"
                typo="span"
                :size="12"
                color="red"
            >
                {{ error }}
            </WText>
        </Transition>
    </div>
</template>

<script>
import VueTypes from 'vue-types'
import { merge } from 'lodash'
import { generateIdMixin } from '@/mixins'

const TYPES = [
    'text',
    'password',
    'email',
    'number',
    'url',
    'tel',
    'search',
    'range',
    'color',
    'date',
    'time',
    'datetime',
    'datetime-local',
    'month',
    'week',
]
export default {
    name: 'WInput',
    mixins: [generateIdMixin],
    props: {
        error: VueTypes.string.def(''),
        name: VueTypes.string.isRequired,
        placeholder: VueTypes.string.def(''),
        readonly: VueTypes.bool.def(false),
        disabled: VueTypes.bool.def(false),
        type: VueTypes.oneOf(TYPES).isRequired,
        align: VueTypes.oneOf(['left', 'right', 'center']).def('left'),
        value: VueTypes.oneOfType([String, Number]),
        iconRight: VueTypes.string.def(''),
        iconLeft: VueTypes.string.def(''),
        iconColor: VueTypes.oneOf([
            'white',
            'primary',
            'secondary',
            'dark',
            'grayMedium',
            'black',
            'yellow',
        ]).def('dark'),
    },
    computed: {
        inputListeners () {
            return merge({}, this.$listeners, {
                input: (event) => {
                    this.$emit('input', event.target.value, this.id)
                },
            })
        },
        inputClass () {
            return [this.align]
        },
    },
}
</script>

<style scoped lang="scss">
@import "@/theme/mixins/_global.scss";

input {
    width: 100%;
    height: $form-height;
    padding: 0 $form-padding;
    border: none;
    border: $form-border;
    border-radius: $border-radius;
    background: transparent;
    color: $form-color;
    font-size: $form-font-size;
    font-weight: $form-font-weight;
    box-sizing: border-box;
    transition: border-color 0.5s ease-in-out;

    @include placeholder {
        color: $form-placeholder-color;
    }
    &:focus {
        border-color: $form-border-color-active;
        outline: none;
    }
    &[readonly] {
        opacity: 0.5;
        cursor: not-allowed;
	}
	&:disabled {
        background-color: $form-disabled-background;
        cursor: not-allowed;
    }
    &.right {
        text-align: right;
    }
    &.center {
        text-align: center;
    }
    &.left {
        text-align: left;
    }
}

.WInput {
    position: relative;
    &.error {
        input {
            border-color: $danger;
        }
    }
}

.WIcon {
    position: absolute;
    top: 33%;
    transform: translateY(-50%);
    &.iconRight {
        right: 12px;
        ~input {
            padding-right: 40px;
        }
    }
    &.iconLeft {
        left: 12px;
        ~input {
            padding-left: 40px;
        }
    }
}

.Error {
    position: absolute;
    top: $form-height + 5px;
    left: 5px;
}
</style>
